import { Record } from 'immutable';

export default Record({
  href: '',
  templated: true,
});
